const IN_PROGRESS_STATUSES = new Set(['BOOKING_IN_PROGRESS', 'TICKET_PENDING'])
const SUCCESS_STATUSES = new Set(['BOOKING_SUCCESS', 'BOOKING_SUCCESSFUL'])

export const isInProgressBookingStatus = (status?: string) => !!status && IN_PROGRESS_STATUSES.has(status)
export const isFailedBookingStatus = (status?: string) => status === 'BOOKING_FAILED'
export const isSuccessBookingStatus = (status?: string) => !!status && SUCCESS_STATUSES.has(status)

export type BookingStatusVisual = 'loading' | 'warning' | 'success'

export const getBookingStatusVisual = (status?: string, isTimedOut = false): BookingStatusVisual => {
    if (isInProgressBookingStatus(status) && !isTimedOut) {
        return 'loading'
    }
    if (isFailedBookingStatus(status) || (isInProgressBookingStatus(status) && isTimedOut)) {
        return 'warning'
    }
    return 'success'
}

export const getBookingStatusUiContent = ({
    status,
    isTimedOut = false,
    isPF = false
}: {
    status?: string
    isTimedOut?: boolean
    isPF?: boolean
}) => {
    const isInProgress = isInProgressBookingStatus(status)
    const isFailed = isFailedBookingStatus(status)
    const visualState = getBookingStatusVisual(status, isTimedOut)

    if (isPF) {
        return {
            headingKey: 'bookingReserved',
            bodyKey: 'bookingPendingFawry',
            visualState,
            showPnrShimmer: isInProgress && !isTimedOut,
            isInProgress,
            isFailed
        }
    }

    const headingKey = isFailed ? 'bookingFailedTitle' : isInProgress ? 'bookingInProgressTitle' : 'bookingConfirmed'
    const bodyKey = isFailed ? 'bookingFailedBody' : isInProgress ? (isTimedOut ? 'bookingInProgressTimedOutBody' : 'bookingInProgressBody') : 'confirmationEmailSent'

    return {
        headingKey,
        bodyKey,
        visualState,
        showPnrShimmer: isInProgress && !isTimedOut,
        isInProgress,
        isFailed
    }
}
